import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	HostListener,
	OnDestroy
} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {OrderChannel} from 'src/app/models/OrderChannels';
import {OrderType} from 'src/app/models/OrderType';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';

interface Channel {
	/** Translation key, resolved by the template so it follows language changes. */
	label: string;
	icon: string;
	selected: boolean;
	value: OrderChannel;
}

@Component({
	selector: 'app-order-type-filter',
	templateUrl: './order-type-filter.component.html',
	styleUrl: './order-type-filter.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTypeFilterComponent implements OnDestroy {
	private readonly onDestroy$ = new Subject<void>();

	isOpen = false;

	channels: Channel[] = [
		{
			label: 'channels.wolt',
			value: PaymentMethod.WOLT,
			icon: 'icon-wolt',
			selected: false
		},
		{
			label: 'channels.uber',
			value: PaymentMethod.UBER_EATS,
			icon: 'icon-uber',
			selected: false
		},
		{
			label: 'channels.lieferando',
			value: PaymentMethod.JET,
			icon: 'icon-lieferando',
			selected: false
		},
		{
			label: 'channels.sot',
			value: OrderType.TERMINAL,
			icon: 'icon-sot',
			selected: false
		},
		{
			label: 'channels.webshop',
			value: OrderType.PREORDER,
			icon: 'icon-app',
			selected: false
		},
		{
			label: 'channels.pos',
			value: OrderType.VIRTUAL,
			icon: 'icon-pos',
			selected: false
		}
	];

	constructor(
		private managerFacade: ManagerFacade,
		private elementRef: ElementRef<HTMLElement>,
		private changeDetector: ChangeDetectorRef
	) {
		this.managerFacade.orderChannelsFilter$
			.pipe(takeUntil(this.onDestroy$))
			.subscribe(channelsFilter => {
				this.channels.forEach(channel => {
					channel.selected = channelsFilter.includes(channel.value);
				});
				this.changeDetector.markForCheck();
			});
	}

	ngOnDestroy() {
		this.onDestroy$.next();
		this.onDestroy$.complete();
	}

	// An empty selection means "no filter", so every order stays visible.
	get selectedCount(): number {
		return this.channels.filter(c => c.selected).length;
	}

	toggleDropdown(): void {
		this.isOpen = !this.isOpen;
	}

	@HostListener('document:click', ['$event.target'])
	onDocumentClick(target: HTMLElement): void {
		if (this.isOpen && !this.elementRef.nativeElement.contains(target)) {
			this.isOpen = false;
		}
	}

	showAll(): void {
		this.channels.forEach(c => (c.selected = false));
		this.updateFiltersInStore();
	}

	toggleChannel(channel: Channel): void {
		channel.selected = !channel.selected;
		this.updateFiltersInStore();
	}

	updateFiltersInStore(): void {
		this.managerFacade.updateOrderChannelFilter(
			this.channels.filter(c => c.selected).map(c => c.value)
		);
	}
}
